import { render, staticRenderFns } from "./atributo.vue?vue&type=template&id=4c910e3d&"
import script from "./atributo.vue?vue&type=script&lang=js&"
export * from "./atributo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports